@if (showIcon) {
<div>
    @if (expansionPanelStyle === 'arrow') {
    <h-svg-icon
        [name]="'arrow-rounded'"
        [@expansionPanelIcon]="collapsed ? 'hidden' : 'visible'"
        [attr.aria-hidden]="'true'"
        class="expansion-panel-icon arrow"></h-svg-icon>
    } @if (expansionPanelStyle === 'plus-minus') {
    <h-svg-icon
        [name]="collapsed ? 'plus' : 'minus'"
        [attr.aria-hidden]="'true'"
        [class.small-dimensions]="shouldPlusMinusSvgHaveSmallDimensions"
        [class.primary-dark-stroke]="shouldPlusMinusSvgHavePrimaryDarkStroke"
        [class.small-stroke-width]="shouldPlusMinusSvgHaveSmallStrokeWidth"
        class="expansion-panel-icon plus-minus"></h-svg-icon>
    }
</div>
}
